import {WPApi} from "../common/wp-api";
import "../common/jquery-functions"

const wp = new WPApi();

let currentActiveTab = 'news';

let currentPage = 1;

jQuery(document).ready(async ($) => {

  //  await displayContentPosts($('.tab-link.selected').attr('id'));

    $(document).on('click', '.load-more', async function () {
        currentPage++;
        $(this).css({
            'opacity': 0.5,
            'pointer-events': 'none'
        });
        await displayContentPosts('post', true, {page: currentPage, posts_only: true});
        $(this).css({
            'opacity': 1,
            'pointer-events': 'unset'
        });
    });


    $('.tab-link').click(async function () {
        if (!$(this).hasClass('selected')) {
            let tabId = $(this).attr('id');
            currentActiveTab = tabId;
            sendEvent('tab-click', getAnalyticsCategorySuffixByTab(tabId));
            $('.tab-link.selected').removeClass('selected');
            $(this).addClass('selected');
            let path = $(this).data('href');
            window.history.pushState('', '', path);

            if ($('.games-top-container').hasClass('d-block')) {
                $('.games-top-container').removeClass('d-block');
                $('.games-top-container').addClass('d-none');
            }
            await displayContentPosts(tabId);
        }
    });

    $(document).on('click', '.players .player-name', function () {
        let label = $(this).text().trim();
        sendEvent('player-click', label);
    });

    $(document).on('click', '.league-header-container', function () {
        let label = $('.player-name', this).text().trim();
        sendEvent('player-click', label);
    });

    $(document).on('click', '.athlete-card', function () {
        let label = $(this).text().trim();
        sendEvent('league-type-click', label);
    });

    $(document).on('click', '.post-card', function () {
        let label = $('h3', this).text().trim();
        sendEvent('news-article-click', label);
    });

    $(document).on('click', '.team-small-game', function () {
        let label = $('.team-name ', this).map(function () {
            return $(this).text().trim();
        }).toArray().join('-');
        sendEvent('game-score-click', label);
    });

    $(document).on('click', '.game-card', function () {

        let teams = $('.team-name', this).map(function () {
            return $(this).text().trim();
        }).toArray().join('-');

        sendEvent('game-click', teams);
    });

    $(document).on('click', '.content-selected .video-card:not(:first-child)', function () {
        let label = $('h3', this).text().trim();
        sendEvent('play', label);
    });

    $(document).on('click', '.content-selected .video-card:first-child', function () {
        sendEvent('game-play', 'main-game');
    });


});


function sendEvent(action, label) {
    let suffix = getAnalyticsCategorySuffixByTab(currentActiveTab);
    let category = `team-page-${suffix}`
    sport1Analytics.sendEvent(category, action, label);
}

function getAnalyticsCategorySuffixByTab(tabId) {

    let suffix;

    switch (tabId) {
        case 'post':
            suffix = 'news';
            break;
        case 'players':
            suffix = 'leagues';
            break;
        case 'video':
            suffix = 'vod';
            break;
        case 'games':
            suffix = 'score';
            break;
        case 'stats':
            suffix = 'table';
            break;
        default:
            suffix = 'news';
            break;
    }

    return suffix;

}


async function displayContentPosts(id, append = false, args = {}) {
    let divContainer = $('.content-selected');

    let urlParams = new URLSearchParams(args);

    let urlRequest = 'sport1/v1/team/' + pageGlobals.object_id + '/' + id + '/content?' + urlParams.toString();
    let response = await wp.get(urlRequest);


    if (!append) {
        divContainer.hide();
        divContainer.html('');
    }

    $('.load-more').remove();
    divContainer.append(response);
    divContainer.fadeIn(200);
    lazyLoader.update();
}
